import React, {CSSProperties} from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {Layout, Menu} from 'antd';
import {HomeOutlined, CloudUploadOutlined, UserOutlined, BuildOutlined} from '@ant-design/icons';
import {observer} from 'mobx-react-lite';
import {useAppStore} from 'hooks/app-store';

import {makeRoute} from '../routes';

interface HeaderProps {
    sidebarOpen: boolean;
}

export const Header = styled.h2<HeaderProps>`
    ${(props) => {
    if (props.sidebarOpen) {
        return `
            padding-top: 18px;
            text-align: center;
            color: white;
        `;
    } else {
        return `
            font-size: 0px;
        `;
    }
}}  
`;

export const Sidebar = observer(() => {
    const appStore = useAppStore();

    const style: CSSProperties = {
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
    };

    return (
        <Layout.Sider
            collapsed={!appStore.sidebarOpen}
            style={style}
        >
            <Header sidebarOpen={appStore.sidebarOpen}>
                Mondly Editor
            </Header>
            <Menu
                mode="inline"
                theme="dark"
            >
                <Menu.Item key="1">
                    <Link to={makeRoute.home()}>
                        <HomeOutlined/>
                        <span>Popups</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to={makeRoute.create()}>
                        <HomeOutlined/>
                        <span>New</span>
                    </Link>
                </Menu.Item>
            </Menu>
        </Layout.Sider>
    );
});